import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    childButton: {
        color: theme.palette.black
    }
}));

export default useStyles;
